<template>
    <div class="content">
        <div class="content_box tableParent public_box">
            <div class="search_box">
                <!--检索部分-->
                <el-form :inline="true" :model="navForm">
                    <el-form-item label="案件号:" prop="keyWord">
                        <el-input class="width_200" v-model="navForm.condition.caseNo" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="是否合格:" prop="deviceType">
                        <el-select class="width_150" v-model="navForm.condition.qualifiedFlag" placeholder="请选择" size="small" clearable>
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报案开始时间:" prop="startTime">
                        <el-date-picker class="forceWidth_190" v-model="navForm.condition.startTime" placeholder="请选择" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="报案结束时间:" prop="endTime">
                        <el-date-picker class="forceWidth_190" v-model="navForm.condition.endTime" placeholder="请选择" type="datetime" size="small" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="风险等级:" prop="startTime">
                        <el-select class="width_150" v-model="navForm.condition.riskLevel" placeholder="请选择" size="small" clearable>
                            <el-option v-for="(item, index) in riskOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button ref="queryBtnRef" class="queryBtn" type="primary" size="small" @click="getTableData" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!--table表格部分-->
            <el-table ref="multipleTable" class="tableHeightAdaptive" :data="tableData" v-loading="tableLoading">
                <el-table-column prop="caseNo" label="案件号"></el-table-column>
                <el-table-column prop="reportTime" label="报案时间"></el-table-column>
                <el-table-column prop="qualifiedFlag" label="是否合格">
                    <template slot-scope="scope">
                        <span>{{ scope.row.qualifiedFlag ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="riskLevel" label="风险等级"></el-table-column>
                <el-table-column prop="riskCount" label="风险点个数"></el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="showDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页部分-->
            <el-pagination style="margin-top: 0.2rem" @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page="navForm.pageNo" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20]" :page-size="navForm.pageSize" :total="navForm.pageTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
let _this;
export default {
    components: {},
    data() {
        return {
            tableLoading: false,
            tableData: [],
            navForm: {
                condition: {
                    caseNo: null,
                    endTime: null,
                    qualifiedFlag: null,
                    riskLevel: null,
                    startTime: null
                },
                orders: [],
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            riskOptions: [
                {
                    label: '高风险',
                    value: '高风险'
                },
                {
                    label: '低风险',
                    value: '低风险'
                },
                {
                    label: '无风险',
                    value: '无风险'
                }
            ],
            productTypeData: [
                {
                    label: '是',
                    value: true
                },
                { label: '否', value: false }
            ]
        };
    },
    mounted() {
        if (localStorage.getItem('qcQueryDataStr')) {
            this.navForm = JSON.parse(localStorage.getItem('qcQueryDataStr'));
        }
        this.getTableData();
    },
    methods: {
        getTableData(queryFlag) {
            if (queryFlag) {
                this.navForm.pageNo = 1;
            }
            this.$request({ method: 'post', url: '/ubi/api/xinjiang/case/page', data: this.navForm }).then((res) => {
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.navForm.pageTotal = res.data.total;
                }
            });
        },
        showDetail(rowItem) {
            let queryDataStr = JSON.stringify(this.navForm);
            localStorage.setItem('qcQueryDataStr', queryDataStr);
            this.$router.push({ path: '/business/specializedQCDetail', query: { id: rowItem.id } });

            // let routeUrl = this.$router.resolve({
            //     path: '/vehicleMap',
            //     query: {
            //         deviceNumber: row.deviceNumber,
            //         startTime: row.tripStartTime,
            //         endTime: row.tripEndTime
            //     }
            // });
            // window.open(routeUrl.href, '_blank');
        },
        handleSizeChange(val) {
            this.navForm.pageNo = 1;
            this.navForm.pageSize = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.navForm.pageNo = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.content {
    position: relative;
    height: 100%;
}
.download_form .el-form-item {
    margin-bottom: 0;
}
.search_box {
    margin-bottom: 20px;
    .form_time {
        width: 350px !important;
        padding-right: 0;
    }
}
.search_box .el-form--inline .el-form-item {
    margin-bottom: 10px;
}
#container,
#conta {
    width: 100%;
    height: 500px;
}
#container /deep/ .BMap_pop {
    left: 264px !important;
    top: 90px !important;
}
#container /deep/ .BMap_pop p {
    line-height: 18px;
}
#container /deep/ .BMap_pop p:nth-child(3) {
    display: inline-block;
    width: 300px;
}
.content {
    position: relative;
    .back_btn {
        position: absolute;
        right: 0px;
        top: -5px;
    }
}
.maxHeight {
    height: 600px !important;
}
.minHeight {
    height: 455px !important;
}

.attachment_dialog {
    /deep/ .el-dialog__body {
        padding-top: 0;
    }
    .dialog_title {
        span {
            color: #333;
            font-size: 16px;
        }
        .warning_type {
            margin: 0 30px;
        }
    }
    .attachment_box {
        height: 550px;
        .box_left {
            width: 780px;
            height: 550px;
            padding-right: 40px;
            border-right: 1px solid #8b8b8b;
            video {
                width: 100%;
                height: 100%;
                // border: 1px solid #ccc;
            }
        }
        .box_right {
            width: 170px;
            height: 550px;
            overflow-y: auto;
            // margin-right: 20px;
            text-align: center;
            padding-left: 25px;
            li {
                width: 120px;
                height: 120px;
                border: 1px solid #ccc;
                margin-bottom: 20px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
                video {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            li:last-child {
                margin-bottom: 0;
            }
            .subsetActive {
                border: 2px solid red !important;
            }
        }
    }
}
</style>


<style lang="less">
</style>